import { ExportableFileSignatureSettings } from "../Api/Dto/ExportableFileSignatureSettings";
import { ExportMode } from "./enum/ExportMode";

export class ExportableFileSignatureSettingsModel {
    public actionType: ExportMode;
    public shouldSign: boolean;

    public constructor(init?: Partial<ExportableFileSignatureSettingsModel>) {
        Object.assign(this, init);
    }

    public static fromCacheModel(model: ExportableFileSignatureSettings): ExportableFileSignatureSettingsModel {
        if (!model)
            return null;

        return new ExportableFileSignatureSettingsModel({
            actionType: model.ActionType,
            shouldSign: model.ShouldSign
        });
    }

    public static fromArrayCacheModel(models: ExportableFileSignatureSettings[]): ExportableFileSignatureSettingsModel[] {
        return models?.map(p => new ExportableFileSignatureSettingsModel({
            actionType: p.ActionType,
            shouldSign: p.ShouldSign
        }));
    }

    public static toCacheModel(model: ExportableFileSignatureSettingsModel): ExportableFileSignatureSettings {
        if (!model)
            return null;

        return new ExportableFileSignatureSettings({
            ActionType: model.actionType,
            ShouldSign: model.shouldSign
        });
    }

    public static toArrayCacheModel(exportableFileSignatureSettings: ExportableFileSignatureSettingsModel[]): ExportableFileSignatureSettings[] {
        return exportableFileSignatureSettings?.map(p => ({
            ActionType: p.actionType,
            ShouldSign: p.shouldSign
        }));
    }
}
